import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import styles from './InternalUseComponent.module.scss';
import metadata from './InternalUseComponent.metadata.json5';

function InternalUseComponent(props) {

    const {
        data: internalUseVM,
        id,
        isSubjectQuote
    } = props;

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, property) => {
           return <span >{item[property.id]}</span>;
        }, [])


    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`internalUseTable`]: {
            data: internalUseVM && internalUseVM.value ? internalUseVM.value : [],
        },
        subjectConditions: {
            visible: isSubjectQuote
         },
         additionalConditions: {
            visible: !isSubjectQuote
         }

    }), [internalUseVM])

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getTableCell
        }
    };

    /* const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            internalUseVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [internalUseVM, overrideProps]
    ); */

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={internalUseVM}
            overrideProps={overrideProps}
            //resolveValue={readValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

InternalUseComponent.propTypes = wizardProps;
export default withRouter(InternalUseComponent);
